import React from 'react';

import { IDesignerHighlight } from '@components/pages/ShopLanding/model/designerHighlight';
import analyticsTrack from '@lib/analytics/analyticsTrack';
import { useTheme } from '@components/theme';
import classNames from 'classnames';
import PrismicImage from '@components/shared/images/atoms/Image/PrismicImage';
import breakpoints from '@constants/breakpoints';
import styles from './DesignerHighlight.module.scss';

const DesignerHighlight = ({
  showSectionToggle,
  title,
  description,
  ctaButton,
  headshotImage,
  collectionImage,
  ctaUrl,
}: IDesignerHighlight) => {
  const trackCtaClick = () => analyticsTrack('cta_clicked', {
    title: `Shop Landing Page | Designer Highlights | ${title}`,
    ctaLabel: 'Shop the Collection'
  });

  if (!showSectionToggle) {
    return null;
  }

  const theme = useTheme();

  return (
    <div className={classNames(styles.Wrapper, theme.styles.Section, theme.styles.Core5)}>
      <div className={styles.DesignerHighlight}>
        <div className={styles.TextSection}>
          <p className={classNames(theme.styles.Overline, styles.Overline)}>Brand Spotlight</p>
          <h2 className={classNames(theme.styles.Header)}>{title}</h2>
          {description && <p className={styles.Description}>{description}</p>}
          <a
            className={classNames(theme.styles.Button, theme.styles.Conflicting)}
            role="button"
            href={ctaUrl}
            onClick={trackCtaClick}
          >
            {ctaButton}
          </a>
        </div>
        <div className={styles.ImagesSection}>
          <a
            aria-label="designer highlight headshot image"
            role="button"
            href={ctaUrl}
            className={styles.ImageButton}
            onClick={trackCtaClick}
          >
            <PrismicImage
              className={styles.HeadShot}
              image={headshotImage}
              breakpoints={{
                mobile: breakpoints['medium-desktop']
              }}
              lazy={false}
            />
          </a>

          <a
            aria-label="designer highlight collection image"
            role="button"
            className={styles.ImageButton}
            href={ctaUrl}
            onClick={trackCtaClick}
          >

            <PrismicImage
              className={styles.Collection}
              image={collectionImage}
              breakpoints={{
                mobile: breakpoints['medium-desktop']
              }}
              lazy={false}
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default DesignerHighlight;
